var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.702,
    fill: "#99A2AD",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.27 28.202c-8.445 0-13.57-5.636-13.77-15h4.277c.134 6.879 3.388 9.794 5.882 10.393V13.202h4.1v5.936c2.405-.256 4.924-2.957 5.77-5.936h4.035c-.646 3.664-3.388 6.364-5.325 7.478 1.939.9 5.058 3.258 6.261 7.522h-4.435c-.936-2.85-3.23-5.058-6.305-5.358v5.358z"
  })));
};
export default SvgVk;